// extracted by css-extract-rspack-plugin
export default {"container":"CommandStarters-module__container__TvPD1","list":"CommandStarters-module__list__KFS6N"};